import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import GlobalDialogContent from "../GlobalDialogContent";
import {
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import CommonTableCell from "../../../components/common/table/CommonTableCell";
import { rupeeAmountDisplay } from "../../../utils/utils";
import { DonorConfig } from "../../../constant/config";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import NotesIcon from '@mui/icons-material/Notes';
import GavelIcon from '@mui/icons-material/Gavel';

const AgencyDetails = () => {
    const projectData = useSelector((state: RootState) => state.dialog.payload);

    return (
        <GlobalDialogContent
            dialogBody={
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#cde2f8' }}> {/* light grey background */}
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} ><strong>#</strong></TableCell>
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} >
                                    <PersonIcon sx={{ verticalAlign: 'middle', fontSize: 16, mr: 0.5 }} />
                                    Agency Name
                                </TableCell>
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} >
                                    <BusinessIcon sx={{ verticalAlign: 'middle', fontSize: 16, mr: 0.5 }} />
                                    Implementation Mode
                                </TableCell>
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} align="right">
                                    <AccountBalanceWalletIcon sx={{ verticalAlign: 'middle', fontSize: 16, mr: 0.5 }} />
                                    Amount
                                </TableCell>
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} >
                                    <NotesIcon sx={{ verticalAlign: 'middle', fontSize: 16, mr: 0.5 }} />
                                    Comment
                                </TableCell>
                                <TableCell sx={{ backgroundColor: '#cde2f8' }} align="center">
                                    <GavelIcon sx={{ verticalAlign: 'middle', fontSize: 16, mr: 0.5 }} />
                                    Status
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {projectData?.agency_allocations?.length > 0 ? (
                                projectData.agency_allocations.map((project: any, index: number) => {
                                    const statusLower = project?.status?.toLowerCase();
                                    let chipLabel = '';
                                    if (project.implementation === 'csr-cell') {
                                        chipLabel = 'Approved';
                                    } else if (statusLower === 'pending' && project?.pending_from?.length) {
                                        chipLabel = 'Pending';
                                    } else {
                                        chipLabel = project?.status?.charAt(0).toUpperCase() + project?.status?.slice(1).toLowerCase();
                                    }

                                    const chipIcon = project.implementation === 'csr-cell' || statusLower === 'approved'
                                        ? <CheckCircleIcon sx={{ color: 'green' }} />
                                        : statusLower === 'rejected'
                                            ? <HighlightOffIcon sx={{ color: 'red' }} />
                                            : <HourglassTopIcon sx={{ color: 'orange' }} />;

                                    const chipColor = project.implementation === 'csr-cell' || statusLower === 'approved'
                                        ? 'success'
                                        : statusLower === 'rejected'
                                            ? 'error'
                                            : 'warning';

                                    return (
                                        <TableRow key={index} hover>
                                            <CommonTableCell value={index + 1} />
                                            <CommonTableCell value={project.agency_user_name || '--CSR-Cell--'} />
                                            <CommonTableCell value={DonorConfig[project.implementation]} />
                                            <CommonTableCell
                                                value={rupeeAmountDisplay(project.allocated_amount)}
                                                style={{ textAlign: 'right' }}
                                            />
                                            <CommonTableCell value={(project?.remark || '').replace(/<[^>]*>/g, '')} />
                                            <CommonTableCell
                                                style={{ textAlign: 'center' }}
                                                value={
                                                    <Chip
                                                        label={chipLabel}
                                                        size="small"
                                                        icon={chipIcon}
                                                        color={chipColor}
                                                        variant="outlined"
                                                    />
                                                }
                                            />
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <Typography variant="body2">No Data Available</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        />
    );
};

export default AgencyDetails;
